<template>
  <div class="mt-5 md:mt-8">
    <PersonWriter />
    <div class="container no-print">
      <LayoutColumns>
        <template #left>
          <ThemeWeeklyTheme v-if="isMm()" class="order-last lg:order-none" />
          <ListNames
            v-else
            class="order-last lg:order-none"
            :count="3"
            placement="side"
          />
          <AdsConceptAd
            v-if="isSite('altinget_dk')"
            :id="`${config.public.site.ads?.placementPrefix}-mkt-promo1`"
            class="order-last lg:order-none"
          />
          <ListArticles
            class="order-last lg:order-none"
            :count="5"
            :offset="0"
            :paper="1"
            label="FrontpageNow"
            type="instream"
            placement="side"
          />
        </template>
        <template #main>
          <ListArticles
            class="order-last lg:order-none"
            :count="8"
            type="writer"
            :lazy="false"
            :preload-first-image="true"
            placement="main"
          />
          <NewsletterSignup class="order-last lg:order-none" />
          <ListArticles
            class="order-last lg:order-none"
            :count="8"
            :offset="8"
            :show-more="true"
            type="writer"
            placement="main"
          />
        </template>
        <template #right>
          <template v-if="isMm()">
            <AdsConceptAd class="hidden lg:block" id="mm-rec1" />
            <AdsConceptAd class="lg:hidden order-last" id="mm-mob1" />
          </template>
          <AdsConceptAd
            v-else-if="isSite('altinget_no')"
            class="lg:hidden order-8"
            id="altinget-mob2"
          />
          <AdsConceptAd v-else class="hidden lg:block" id="altinget-rec1" />
          <ListJobs
            class="order-last lg:order-none"
            :count="5"
            :random="true"
          />
        </template>
      </LayoutColumns>
    </div>
  </div>
</template>

<script setup lang="ts">
const config = useRuntimeConfig()
const nuxtApp = useNuxtApp()
const route = useRoute()
const indexStore = useIndexStore()

if (!indexStore.currentPaper) {
  throw createError({ statusCode: 404 })
}

useSeoMeta({
  title: indexStore.currentPaperSlug
    ? config.public.site.meta.title.postfix.short +
      indexStore.currentPaper?.Name
    : config.public.site.meta.title.postfix.long,
})

// Make frontpage paper the canonical URL to avoid duplicates in search results
useHead({
  link: [
    {
      rel: 'canonical',
      href: `https://${config.public.site.url}/${nuxtApp.$t('Routes.Writer')}/${
        route.params.writer
      }`,
    },
  ],
})
</script>
